import { combineReducers } from "redux";

import language from "./language";
import login from "./login";
import inputLogin from "./login";
import orders from "./orders";
import orderList from "./orderList";
import freeGates from "./freeGates";
import scheduling from "./scheduling";
import relatorio from "./relatorio";
import authentication from "./authentication";
import authorization from "./authorization";
import reconcile from "./reconcile";
import conciliationResult from "./conciliationResult";
import conciliationSeal from "./conciliationSeal";
import load from "./load";
import ordersModal from "./ordersModal";
import cdList from "./cdList";
import cdDetails from "./cdDetails";
import cdGates from "./cdGates";
import cdExceptions from "./cdExceptions";
import itemList from "./itemList";
import measurementChart from './measurementChart';
import tag from './tag';
import printer from './printer';
import filter from './orderFilter';
import register from './register';
import gateVariations from "./gateVariations";
import provider from "./provider";
import producerDeclaration from "./producerDeclaration";
import declarationFilter from './declarationFilter';
import sustainabilityFilter from './sustainabilityFilter';
import preScheduling from './preScheduling';
import conciliationReport from './conciliationReport';
import subcontractor from './subcontractor';
import orderSample from './orderSample';
import idgfPowerBi from './idgfPowerBi';
import originCertificate from './originCertificate';

export default combineReducers({
    language,
    login,
    orders,
    orderList,
    inputLogin,
    freeGates,
    scheduling,
    relatorio,
    authentication,
    authorization,
    reconcile,
    conciliationResult,
    conciliationSeal,
    load,
    ordersModal,
    cdList,
    cdDetails,
    cdGates,
    cdExceptions, 
    itemList,
    measurementChart,
    tag,
    printer,
    filter,
    register,
    gateVariations,
    provider,
    producerDeclaration,
    declarationFilter,
    sustainabilityFilter,
    preScheduling,
    conciliationReport,
    subcontractor,
    orderSample,
    idgfPowerBi,
    originCertificate,
});
